/* ============================================================================
   whatsapp-widget.js
   ============================================================================ */

(function () {
  "use strict";

  /* ========================================================================== 
     TEAM EDIT AREA — edit only these 2 sections.
     ========================================================================== */
  var CONFIG = {

    /* 1) WhatsApp number */
    WA_NUMBER: "919964080800",

    /* 2) Google Sheet click-tracking endpoint */
    CLICK_LOG_URL: "https://script.google.com/macros/s/AKfycbzymZieovW-g4ONKNAFzwsOl9HDGFegbJ3OMNWgzZjYgULY412rBh7jH_sECshbvSN0dw/exec",

    /* ======================= END OF TEAM EDIT AREA ======================= */

    MESSAGE: "Need help?",
    SESSION_TIMEOUT_MS: 60 * 60 * 1000,
    ANIMATE_ON_VISITS: [1, 2],
    INIT_DELAY_MS: 1000,
    TYPE_MS: 100,
    SHOW_MS: 7000,
    PULSE_MS: 10000,
    CYCLES: 5,

    KEYS: {
      VISIT_COUNT:      "bs_widget_visit_count",
      SESSION_ID:       "bs_widget_session_id",
      SESSION_LAST_SEEN:"bs_widget_session_last_seen",
      SESSION_COUNTED:  "bs_widget_session_counted"
    },

    CYCLE_KEY: "wa_widget_cycle"
  };


  function computeVisitCount() {
    try {
      var now = Date.now();
      var lastSeenRaw = localStorage.getItem(CONFIG.KEYS.SESSION_LAST_SEEN);
      var lastSeen = parseInt(lastSeenRaw, 10);
      var count = parseInt(localStorage.getItem(CONFIG.KEYS.VISIT_COUNT), 10) || 0;

      var isNewVisit =
        !lastSeenRaw || isNaN(lastSeen) ||
        (now - lastSeen > CONFIG.SESSION_TIMEOUT_MS);

      if (isNewVisit) {
        count = count + 1;
        localStorage.setItem(CONFIG.KEYS.VISIT_COUNT, String(count));
        localStorage.setItem(
          CONFIG.KEYS.SESSION_ID,
          String(now) + "-" + Math.random().toString(36).slice(2, 8)
        );
        try { sessionStorage.setItem(CONFIG.KEYS.SESSION_COUNTED, "1"); } catch (e) {}
      }

      localStorage.setItem(CONFIG.KEYS.SESSION_LAST_SEEN, String(now));

      return count < 1 ? 1 : count;
    } catch (e) {
      return 1;
    }
  }

  if (typeof window.bsVisitCount !== "number") {
    window.bsVisitCount = computeVisitCount();
  }

  window.bsGetVisitCount = function () { return window.bsVisitCount; };

  var visitCount = window.bsVisitCount;


  function getAnimationCycle() {
    try {
      var raw = localStorage.getItem(CONFIG.CYCLE_KEY);
      var data = raw ? JSON.parse(raw) : {};
      if (data && typeof data === "object") {
        return parseInt(data[String(visitCount)], 10) || 0;
      }
      return 0;
    } catch (e) {
      return 0;
    }
  }

  function setAnimationCycle(value) {
    try {
      var raw = localStorage.getItem(CONFIG.CYCLE_KEY);
      var data = raw ? JSON.parse(raw) : {};
      if (!data || typeof data !== "object") data = {};
      data[String(visitCount)] = value;
      localStorage.setItem(CONFIG.CYCLE_KEY, JSON.stringify(data));
    } catch (e) {}
  }


  function logWaClick() {
    if (!CONFIG.CLICK_LOG_URL) return;
    try {
      var params = new URLSearchParams(window.location.search);
      var qs = new URLSearchParams({
        page:         window.location.pathname,
        url:          window.location.href.split("#")[0],
        utm_source:   params.get("utm_source")   || "",
        utm_medium:   params.get("utm_medium")   || "",
        utm_campaign: params.get("utm_campaign") || "",
        utm_content:  params.get("utm_content")  || "",
        utm_term:     params.get("utm_term")      || "",
        gclid:        params.get("gclid")         || "",
        fbclid:       params.get("fbclid")        || "",
        referrer:     document.referrer           || "",
        visit_count:  String(visitCount),
        v:            String(Date.now())
      });
      (new Image()).src = CONFIG.CLICK_LOG_URL + "?" + qs.toString();
    } catch (e) {}
  }

  function openWA() {
    logWaClick();
    window.open("https://wa.me/" + CONFIG.WA_NUMBER, "_blank", "noopener");
  }


  function initWhatsAppWidget() {
    if (document.getElementById("wa-widget")) return;

    var shouldAnimate = (CONFIG.ANIMATE_ON_VISITS.indexOf(visitCount) !== -1);

    var cycle = getAnimationCycle();

    var widget = document.createElement("div");
    widget.id = "wa-widget";
    widget.innerHTML =
      '<div id="wa-bubble" tabindex="0" aria-label="Chat on WhatsApp">' +
        '<div id="wa-msg"></div>' +
        '<div id="wa-time"></div>' +
        '<div id="wa-close" aria-label="Close">&times;</div>' +
      '</div>' +
      '<div id="wa-iconWrap" tabindex="0" role="button" aria-label="Open WhatsApp chat">' +
        '<img id="wa-img" src="' + (window.WA_ICON_URL || "") + '" alt="WhatsApp">' +
        '<div id="wa-badge">1</div>' +
      '</div>';
    document.body.appendChild(widget);

    var bubbleEl = widget.querySelector("#wa-bubble"),
        msgSpan  = widget.querySelector("#wa-msg"),
        timeEl   = widget.querySelector("#wa-time"),
        closeBtn = widget.querySelector("#wa-close"),
        iconWrap = widget.querySelector("#wa-iconWrap");

    bubbleEl.addEventListener("click", openWA);
    iconWrap.addEventListener("click", openWA);

    function keyOpen(e) {
      if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
        openWA();
      }
    }
    bubbleEl.addEventListener("keydown", keyOpen);
    iconWrap.addEventListener("keydown", keyOpen);

    closeBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      bubbleEl.style.display = "none";
    });

    function setTime() {
      var d  = new Date(),
          hh = String(d.getHours()).padStart(2, "0"),
          mm = String(d.getMinutes()).padStart(2, "0");
      timeEl.textContent = hh + ":" + mm;
    }
    setTime();
    setInterval(setTime, 60000);

    function addPulse()    { iconWrap.classList.add("pulse"); }
    function removePulse() { iconWrap.classList.remove("pulse"); }

    function type(i) {
      i = i || 0;

      if (!shouldAnimate) {
        removePulse();
        bubbleEl.style.display = "none";
        return;
      }

      if (cycle >= CONFIG.CYCLES) {
        removePulse();
        bubbleEl.style.display = "none";
        return;
      }

      if (i <= CONFIG.MESSAGE.length) {
        msgSpan.textContent = CONFIG.MESSAGE.slice(0, i);
        setTimeout(function () { type(i + 1); }, CONFIG.TYPE_MS);
      } else {
        setTimeout(function () {
          bubbleEl.style.display = "none";
          addPulse();
          cycle++;
          setAnimationCycle(cycle);

          setTimeout(function () {
            removePulse();
            bubbleEl.style.display = "block";
            msgSpan.textContent = "";
            type();
          }, CONFIG.PULSE_MS);

        }, CONFIG.SHOW_MS);
      }
    }

    type();
  }


  /* ========================================================================== 
     START — as soon as the DOM is ready.
     Also works when this script is loaded after DOMContentLoaded has fired.
     The original 7000 ms widget delay is preserved.
     ========================================================================== */
  function onDomReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
    } else {
      callback();
    }
  }

  onDomReady(function () {
    setTimeout(initWhatsAppWidget, CONFIG.INIT_DELAY_MS);
  });

})();
